var _style, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "social_links",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.3;enable-background:new    ;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "container",
    className: "st0",
    cx: 20,
    cy: 20,
    r: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "email_00000100367368026588401900000005671190368055169699_",
    className: "st1",
    d: "M9.7,19.9L28,12.2c0.1-0.1,0.3,0.1,0.3,0.2 l-2.6,15.7c-0.1,0.5-0.7,0.8-1.1,0.5l-7.2-5c-0.2-0.1-0.2-0.4,0-0.5l6.9-6.7c0.2-0.2,0-0.5-0.3-0.3l-9.4,6.1 c-0.3,0.2-0.6,0.2-0.9,0.1l-3.8-1.5C9.4,20.6,9.4,20.1,9.7,19.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialEmail);
export default __webpack_public_path__ + "static/media/social-email.350ffe8c917b3ac4c14dc96027870f3b.svg";
export { ForwardRef as ReactComponent };